import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-63c154f0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "artlist"
};
const _hoisted_2 = {
  class: "data-list-top"
};
const _hoisted_3 = {
  class: "van-sticky"
};
const _hoisted_4 = {
  "data-v-3bb62a91": "",
  class: "head-wrap"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "van-icon van-icon-arrow-left"
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "返回", -1));
const _hoisted_7 = [_hoisted_5, _hoisted_6];
const _hoisted_8 = {
  class: "head-top"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "head-absolute"
}, null, -1));
const _hoisted_10 = {
  class: "data-list-top",
  style: {
    "position": "fixed",
    "width": "100%",
    "max-width": "540px",
    "top": "0",
    "z-index": "5"
  }
};
const _hoisted_11 = {
  class: "van-sticky"
};
const _hoisted_12 = {
  "data-v-3bb62a91": "",
  class: "head-wrap"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "van-icon van-icon-arrow-left"
}, null, -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "返回", -1));
const _hoisted_15 = [_hoisted_13, _hoisted_14];
const _hoisted_16 = {
  class: "head-top"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "head-absolute"
}, null, -1));
const _hoisted_18 = {
  class: "main"
};
const _hoisted_19 = {
  class: "titles"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
  class: "content"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "66px"
  }
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Zoushi = _resolveComponent("Zoushi");
  const _component_Tongji = _resolveComponent("Tongji");
  const _component_Yilou = _resolveComponent("Yilou");
  const _component_Kjdate = _resolveComponent("Kjdate");
  const _component_Tiaoma = _resolveComponent("Tiaoma");
  const _component_Jixuan = _resolveComponent("Jixuan");
  const _component_Xingyun = _resolveComponent("Xingyun");
  const _component_Boxiao = _resolveComponent("Boxiao");
  const _component_Fushi = _resolveComponent("Fushi");
  const _component_v_foot = _resolveComponent("v-foot");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("a", {
    onClick: _cache[0] || (_cache[0] = $event => $options.fanhui())
  }, _hoisted_7), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", null, _toDisplayString($data.titles[$data.id]), 1)]), _hoisted_9])])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("a", {
    onClick: _cache[1] || (_cache[1] = $event => $options.fanhui())
  }, _hoisted_15), _createElementVNode("div", _hoisted_16, [_createElementVNode("span", null, _toDisplayString($data.titles[$data.id]), 1)]), _hoisted_17])])]), _createElementVNode("div", _hoisted_18, [_withDirectives(_createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.titles, (v, i) => {
    return _withDirectives((_openBlock(), _createElementBlock("div", {
      key: i,
      style: _normalizeStyle('background:' + $data.color[i]),
      onClick: $event => $data.id = i
    }, _toDisplayString(v), 13, _hoisted_20)), [[_vShow, i > 0]]);
  }), 128))], 512), [[_vShow, $data.id == 0]]), _withDirectives(_createElementVNode("div", _hoisted_21, [$data.id == 1 ? (_openBlock(), _createBlock(_component_Zoushi, {
    key: 0,
    data: $data.data
  }, null, 8, ["data"])) : _createCommentVNode("", true), $data.id == 2 ? (_openBlock(), _createBlock(_component_Tongji, {
    key: 1,
    data: $data.data
  }, null, 8, ["data"])) : _createCommentVNode("", true), $data.id == 3 ? (_openBlock(), _createBlock(_component_Yilou, {
    key: 2,
    data: $data.data
  }, null, 8, ["data"])) : _createCommentVNode("", true), $data.id == 4 ? (_openBlock(), _createBlock(_component_Kjdate, {
    key: 3,
    type: $options.typeID
  }, null, 8, ["type"])) : _createCommentVNode("", true), $data.id == 5 ? (_openBlock(), _createBlock(_component_Tiaoma, {
    key: 4,
    type: $options.typeID
  }, null, 8, ["type"])) : _createCommentVNode("", true), $data.id == 6 ? (_openBlock(), _createBlock(_component_Jixuan, {
    key: 5,
    type: $options.typeID
  }, null, 8, ["type"])) : _createCommentVNode("", true), $data.id == 7 ? (_openBlock(), _createBlock(_component_Xingyun, {
    key: 6,
    type: $options.typeID
  }, null, 8, ["type"])) : _createCommentVNode("", true), $data.id == 8 ? (_openBlock(), _createBlock(_component_Boxiao, {
    key: 7,
    type: $options.typeID
  }, null, 8, ["type"])) : _createCommentVNode("", true), $data.id == 9 ? (_openBlock(), _createBlock(_component_Fushi, {
    key: 8,
    type: $options.typeID
  }, null, 8, ["type"])) : _createCommentVNode("", true)], 512), [[_vShow, $data.id != 0]])]), _hoisted_22, _createVNode(_component_v_foot)]);
}